import { render } from "./farmerManage.vue?vue&type=template&id=744c04e2&ts=true"
import script from "./farmerManage.vue?vue&type=script&lang=ts"
export * from "./farmerManage.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/A-生产-h5-prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__